import { useRouter } from "next/router"
import { useState } from "react"
import { Portal } from "react-portal"
import { FreeMode, Navigation, Thumbs } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import { Image, RatioImage } from "@components/anti/Image"
import Link from "@components/anti/Link"
import SwiperNavigation from "@components/global/SwiperNavigation"
import { translations } from "src/helper/translations"
import { useCustomNavSwiper, useScrollAnim } from "src/hooks/hooks"
import { convertJson, imgUrl, imgUrlDownload } from "src/mixins"

function NewsroomMediaGallery({ isOpen, onClose, galleryItem }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [activeIndex, setActiveIndex] = useState(0)
  const [swiperRef, handlePrev, handleNext] = useCustomNavSwiper()
  const router = useRouter()
  const { locale } = router
  return (
    <>
      {isOpen && (
        <Portal>
          <div className="newsroom-media-gallery fadeIn">
            <div
              className="close-btn"
              onClick={() => onClose()}
              role="presentation"
            >
              <i className="air ai-times" />
            </div>
            <div className="container mw-xl py-main">
              <div className="row-title">
                <h2 className="newsroom-media-gallery__title">
                  {galleryItem?.title}{" "}
                  <small>
                    {activeIndex + 1}/{convertJson(galleryItem.items)?.length}
                  </small>
                </h2>
                {/* <Link
                  href={galleryItem?.download_all_url}
                  className="download-all"
                >
                  <h6>
                    {translations[`download_all_photos_${locale}`]}{" "}
                    <i className="cxi-download" />
                  </h6>
                </Link> */}
              </div>
              <div className="newsroom-media-gallery__content">
                <SwiperNavigation
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                />
                <Swiper
                  ref={swiperRef}
                  loop
                  spaceBetween={10}
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                  onBeforeInit={(swiper) => {
                    swiperRef.current = swiper
                  }}
                  onSlideChange={(e) => setActiveIndex(e.realIndex)}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="newsroom-media-gallery__swiper-main"
                >
                  {convertJson(galleryItem.items)?.map((item, i) => (
                    <SwiperSlide
                      key={`newsroom-media-gallery__swiper-main-item-${i}`}
                    >
                      <div className="row mx-0">
                        <div className="col-md-7 col-img">
                          <div className="img-wrapper">
                            <Image
                              src={imgUrl(item.image)}
                              className="img-fluid"
                              alt={`newsroom-media-gallery__swiper-main-item-${i}`}
                              fill
                            />
                          </div>
                        </div>
                        <div className="col-md-5 col-text">
                          <h2 className="title">{item.filename}</h2>
                          <small className="img-size">{item.size}</small>
                          <Link
                            href={imgUrlDownload(item.image)}
                            target="_blank"
                            className="download-btn"
                          >
                            <h5>
                              {translations[`download_${locale}`]}{" "}
                              <i className="cxi-download" />
                            </h5>
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Swiper
                  onSwiper={setThumbsSwiper}
                  // loop
                  spaceBetween={15}
                  slidesPerView={4}
                  breakpoints={{
                    365: {
                      slidesPerView: 4,
                      spaceBetween: 15,
                    },
                    768: {
                      slidesPerView: 6.5,
                      spaceBetween: 15,
                    },
                    1024: {
                      slidesPerView: 6.5,
                      spaceBetween: 15,
                    },
                  }}
                  freeMode
                  watchSlidesProgress
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="newsroom-media-gallery__swiper-nav"
                >
                  {convertJson(galleryItem.items)?.map((item, i) => (
                    <SwiperSlide
                      key={`newsroom-media-gallery__swiper-nav-item-${i}`}
                      className={`newsroom-media-gallery__swiper-nav-item ${
                        activeIndex === i ? "active" : ""
                      }`}
                    >
                      <RatioImage
                        src={imgUrl(item.image)}
                        className="img-fluid"
                        alt={`newsroom-media-gallery__swiper-nav-item-${i}`}
                        ratio="r-4-3"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  )
}

export default NewsroomMediaGallery
